import * as lz4 from "lz4js";

function encodeToSharedArrayBuffer(jsonObject, sharedArray) {
  const jsonString = JSON.stringify(jsonObject);
  const encoder = new TextEncoder(); // Encode the string as a Uint8Array
  const encoded = encoder.encode(jsonString);

  // Write the encoded data into the SharedArrayBuffer
  for (let i = 0; i < encoded.length; i++) {
    sharedArray[i + 2] = encoded[i]; // Store starting from index 1
  }

  // Set the second element to length of encoded data
  Atomics.store(sharedArray, 1, encoded.length);

  // Set the first element to 1 to indicate data is written
  Atomics.store(sharedArray, 0, 1);
  Atomics.notify(sharedArray, 0, 1);
}

function decodeFromSharedArrayBuffer(sharedArray) {
  const decoder = new TextDecoder();
  const length = sharedArray[1];

  const tempBuffer = new ArrayBuffer(length);
  const tempView = new Uint8Array(tempBuffer);

  let sharedView = new Uint8Array(sharedArray)
  sharedView = sharedView.subarray(2, length+2)
  tempView.set(sharedView)

  const jsonString = decoder.decode(tempView);

  return JSON.parse(jsonString);
}

async function getPNGPixels(url) {
  const img = new Image();
  img.src = url;

  await img.decode();

  const canvas = document.createElement("canvas");
  canvas.width = img.width;
  canvas.height = img.height;

  const ctx = canvas.getContext("2d");
  ctx.drawImage(img, 0, 0);

  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const data = imageData.data; // Uint8ClampedArray (RGBA)

  // Convert to 2D array: [y][x] = [r,g,b,a]
  const pixels = [];
  for (let y = 0; y < canvas.height; y++) {
    const row = [];
    for (let x = 0; x < canvas.width; x++) {
      const i = (y * canvas.width + x) * 4;
      row.push([
        data[i],     // R
        data[i + 1], // G
        data[i + 2], // B
        data[i + 3], // A
      ]);
    }
    pixels.push(row);
  }

  return pixels;
}

function countBits(n) {
  let count = 0;
  while (n) {
    n &= (n - 1);
    count++;
  }
  return count;
}

const bitCounts = new Uint8Array(256);
for (let i = 0; i < 256; i++) {
  bitCounts[i] = countBits(i);
}

function countBitsByte(n) {
  return bitCounts[n & 0xff];
}

async function loadFile(url) {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Failed to load file: ${url}`);
  }
  return await response.text();
}

async function loadBinaryFile(url) {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Failed to load file: ${url}`);
  }

  return await response.arrayBuffer();
}

async function loadBinaryLz4File(url) {
  const response = await fetch(url);
  if (!response.ok) throw new Error(`Failed: ${url}`);

  const compressed = new Uint8Array(await response.arrayBuffer());
  const decompressed = lz4.decompress(compressed);

  return decompressed.buffer;
}

export {encodeToSharedArrayBuffer, decodeFromSharedArrayBuffer, getPNGPixels, countBitsByte, loadFile, loadBinaryFile, loadBinaryLz4File};
